import React from 'react';
import {Typography, Box, Card, CardMedia, Grid} from '@material-ui/core/';
import img from "./CommissionsTooHigh.png";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    root: {
        maxWidth: 500,
        maxHeight:300
    },
    media: {
      height: 300,
      width: 500
    },
});

export default function Ally(props){
    const classes = useStyles();
    return(
        <div>
        <Box mt={5} mb={2}>
        <Grid container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
            >
        <Grid item xs={12}>
        <Card className={classes.root}>
            <CardMedia className={classes.media} image={img}/>
        </Card>
        </Grid>
        </Grid>
        </Box>
        <Box p={3}>
        <Typography variant='h5' gutterBottom>A viral post in March showed that a restaurant owner kept only ~36% of his sales through GrubHub. A few weeks later, states started to cap commissions and a class-action federal lawsuit was filed for deceptive practices.</Typography>
        </Box>
        <Box p={1}>
        <Typography variant='h5'>We are helping restaurants just like the ones you love in your community, <strong>please sign and share <a href='https://www.gigworkerscollective.org/'>this</a> open letter</strong> on their behalf!</Typography>
        </Box>
        </div>
    );
}